module.exports = __webpack_public_path__ + "static/img/brees-2001-top.428c522.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2001-top.jpg
// module id = OOET
// module chunks = 1